import { createFileRoute } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { HomeSellFlow } from "@/components/home/HomeSellFlow";
import { latestAdsQueryOptions } from "@/lib/latest-ads";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Sälj dina prylar – gratis annons på en minut | Sellavo" },
      {
        name: "description",
        content:
          "Sälj begagnat snabbt: fota prylen, få färdig annonstext och prisförslag av oss och publicera gratis. Köp och sälj begagnat i hela Sverige på Sellavo.",
      },
      {
        property: "og:title",
        content: "Sälj dina prylar – gratis annons på en minut | Sellavo",
      },
      {
        property: "og:description",
        content:
          "Fota prylen, få färdig annonstext och prisförslag och lägg ut din begagnatannons gratis – klart på under en minut.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://sellavo.com/" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "Sellavo",
          description:
            "Köp och sälj begagnat i Sverige. Fota prylen, få färdig annonstext och prisförslag och lägg ut annonsen gratis.",
          url: "https://sellavo.com/",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://sellavo.com/annonser?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }),
      },
    ],
  }),

  // Prefetch utan await: sidan börjar strömma direkt och annonslistan
  // fylls i när svaret kommer (den renderas i en egen Suspense-gräns).
  loader: ({ context }: { context: { queryClient: QueryClient } }) => {
    void context.queryClient.prefetchQuery(latestAdsQueryOptions());
  },

  component: HomePage,
});

function HomePage() {
  return <HomeSellFlow />;
}
